import { zodResolver } from '@hookform/resolvers/zod';
import { ClarificationReason } from '@pelicargo/types';
import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { useAuth } from '../../context/AuthProvider';
import {
  getCustomerDefaultsFromRequest,
  getSharedAirlineDefaultsFromRequest,
  recipientValidationSchema,
  SharedEmailValidationSchema,
} from '../../utils/email';
import { Request } from '../../utils/types';

const validationSchema = z.object({
  ...SharedEmailValidationSchema,
  isLongEmail: z.boolean(),
  clarificationReason: z.nativeEnum(ClarificationReason).nullish(),
  recipients: z.array(recipientValidationSchema).min(1),
});

export type ClarificationRequestValues = z.infer<typeof validationSchema>;

export const useCustomerClarificationRequestForm = (request?: Request) => {
  const { user } = useAuth();
  const defaultValues = useMemo(() => {
    return {
      ...getSharedAirlineDefaultsFromRequest(request),
      ...getCustomerDefaultsFromRequest(request),
      isLongEmail: false,
      senderContactId: user?.contact_id,
    };
  }, [request, user?.contact_id]);

  const methods = useForm<Partial<ClarificationRequestValues>>({
    mode: 'onSubmit',
    resolver: zodResolver(validationSchema),
    defaultValues,
  });

  return { methods };
};
